<script setup lang="ts"></script>

<template>
  <div
    class="relative flex max-w-[24rem] rotate-2 items-center overflow-hidden rounded-xl bg-main-50 p-2 bordershadow-lg-main"
  >
    <Gradient
      id="business-card"
      class="z-0 aspect-[16/10] h-full w-full rounded bordershadow-main-light"
      :gradient-options="{amplitude: 10, density: [0.1, 0.01]}"
    />
    <div class="absolute right-4 h-12 w-2 rounded-full border border-main-400 bg-main-50 shadow-inner"></div>

    <div class="absolute inset-0 flex h-full w-full flex-col justify-end p-6">
      <img
        src="/ceo.jpg"
        class="absolute -right-1 -top-1 h-20 w-20 rounded-full rounded-tr-none border border-main-400 object-cover"
      />

      <Heading size="medium" class="mb-2 w-full">
        {{ $t('contact.business_card.title') }}
      </Heading>

      <Paragraph size="normal" class="w-3/4">
        {{ $t('contact.business_card.description') }}
      </Paragraph>
    </div>
  </div>
</template>
